import React, {useMemo, memo, useContext} from 'react';
import CheckBox from "./check-box";
import PrefixBlock from "./prefix-block";
import LinkTitle from "./link-title";
import './lot-title.css';
import BadgesBlock from "./badges-block";

import {lotContext} from "../../auction-lots-listing/components/lots-list-item/lots-list-item";
import {LotsContext} from "../../auction-lots-listing/auction-lots-listing";

const LotTitle = memo(() => {
    const {lotData} = useContext(lotContext);
    const {
        user_lots_type,
        visitor: {
        user_id: visitor_user_id,
        permissions: {
            auctions: {
                deleteLots,
                RestoreLots,
                view_all_bids
            }
        }
    }} = useContext(LotsContext);


    const {auction_id, user_id: auction_user_id, status, prefix_id} = lotData;

    const checkCondition = useMemo(() => {
        const statusType = ['nosale', 'sale', 'finalized', 'active'];
        return ((visitor_user_id === auction_user_id || deleteLots || RestoreLots || view_all_bids)
            && statusType.includes(status));

    }, [visitor_user_id, auction_user_id, deleteLots, RestoreLots, view_all_bids, status]);

    const isArchive = user_lots_type === 'archive_lots';
    const showCheckbox = !isArchive && checkCondition;


    return (
        <div className={showCheckbox ? 'form-check' : 'd-flex'}>
            {showCheckbox && <CheckBox/>}
            <label data-action 
                   className={showCheckbox ? 'form-check-label' : ''} 
                   htmlFor={`lot_${auction_id}_title`}>
                <div className="d-flex">
                    <div className="flex-fill">
                        {(prefix_id !== 0) && <PrefixBlock/>}
                        <LinkTitle/>
                        <BadgesBlock/>
                    </div>
                </div>
            </label>
        </div>
    );
});

export default LotTitle;